import text from './FormNormalInput.vue'
const FormNormalInput = {
  install: function (Vue) {
    Vue.component('FormNormalInput', text)
  }
}
export default FormNormalInput
